import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createSlots as _createSlots, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex flex-row flex-wrap" }
const _hoisted_2 = { class: "col-12 xl:col-12" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "grid" }
const _hoisted_5 = { class: "col-fixed align-self-end align-items-center" }
const _hoisted_6 = {
  key: 0,
  class: "pi pi-lock-open",
  style: {"font-size":"1.5rem"}
}
const _hoisted_7 = {
  key: 1,
  class: "pi pi-lock",
  style: {"font-size":"1.5rem"}
}
const _hoisted_8 = {
  style: {"margin":"10px"},
  class: "flex"
}
const _hoisted_9 = { class: "w-100pc p-input-icon-left p-input-icon-right" }
const _hoisted_10 = {
  key: 0,
  class: "align-items-center"
}
const _hoisted_11 = { class: "grid pt-2 ml-2 search-panel" }
const _hoisted_12 = { class: "flex align-items-center" }
const _hoisted_13 = { class: "flex align-items-center ml-4" }
const _hoisted_14 = { class: "flex align-items-center ml-4" }
const _hoisted_15 = { style: {"padding":"10px","width":"100%","padding-top":"0px"} }
const _hoisted_16 = { class: "col-12 property-service-item hover-row" }
const _hoisted_17 = { class: "col service-name compass-red" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  key: 1,
  style: {"margin-left":"50px","margin-top":"4px"}
}
const _hoisted_20 = { class: "col-1 hidden xl:block" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "col-1 hidden xl:block" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { class: "col-1 hidden xl:block" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { class: "col-1 hidden xl:block" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { class: "col-1 hidden xl:block" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = {
  class: "text-center col-fixed",
  style: {"width":"100px"}
}
const _hoisted_31 = {
  key: 0,
  class: "pi pi-check"
}
const _hoisted_32 = {
  class: "col-2",
  style: {"text-align":"left"}
}
const _hoisted_33 = ["onClick"]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { class: "col-10" }
const _hoisted_36 = { class: "notes-block" }
const _hoisted_37 = {
  key: 0,
  class: "notes-block-label mr-4"
}
const _hoisted_38 = { class: "notes-block-content" }
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { class: "new-service" }
const _hoisted_41 = { class: "col-12 property-service-item" }
const _hoisted_42 = { class: "grid flex" }
const _hoisted_43 = { class: "col-12 service-name compass-red" }
const _hoisted_44 = { class: "col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_TextArea = _resolveComponent("TextArea")!
  const _component_DataView = _resolveComponent("DataView")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[11] || (_cache[11] = _createElementVNode("div", { class: "col" }, [
              _createElementVNode("h4", null, "Service Definitions")
            ], -1)),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("a", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.editMode=!_ctx.editMode;_ctx.editModeChanged()})
              }, [
                (_ctx.editMode)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_6))
                  : _createCommentVNode("", true),
                (!_ctx.editMode)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_7))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _cache[12] || (_cache[12] = _createElementVNode("i", { class: "pi pi-home" }, null, -1)),
              _createVNode(_component_InputText, {
                modelValue: _ctx.serviceListFilter,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.serviceListFilter) = $event)),
                placeholder: "Service keyword filter.."
              }, null, 8, ["modelValue"]),
              _cache[13] || (_cache[13] = _createElementVNode("i", { class: "pi pi-search" }, null, -1))
            ]),
            (_ctx.editMode)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createVNode(_component_Button, {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showAddService = true)),
                    class: "ml-1 mr-1",
                    icon: "pi pi-plus"
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_InputSwitch, {
                modelValue: _ctx.activeServicesOnly,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.activeServicesOnly) = $event)),
                onChange: _ctx.loadServices
              }, null, 8, ["modelValue", "onChange"]),
              _cache[14] || (_cache[14] = _createElementVNode("span", { class: "ml-1" }, "Only active", -1))
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_InputSwitch, {
                modelValue: _ctx.onlyServicesInUse,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.onlyServicesInUse) = $event)),
                onChange: _ctx.loadServices
              }, null, 8, ["modelValue", "onChange"]),
              _cache[15] || (_cache[15] = _createElementVNode("span", { class: "ml-1" }, "Only services in use", -1))
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_InputSwitch, {
                modelValue: _ctx.onlyParentServices,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.onlyParentServices) = $event)),
                onChange: _ctx.loadServices
              }, null, 8, ["modelValue", "onChange"]),
              _cache[16] || (_cache[16] = _createElementVNode("span", { class: "ml-1" }, "Only parent services", -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_DataView, {
              value: _ctx.filteredServices,
              datakey: "serviceId",
              paginator: true,
              rows: 10,
              scrollable: true,
              stripedRows: "",
              class: "p-datatable-sm property-service-table",
              paginatorTemplate: _ctx.paginatorTemplate,
              rowsPerPageOptions: [10,20,50,100,200],
              responsiveLayout: "scroll",
              alwaysShowPaginator: false,
              currentPageReportTemplate: "Showing {first} to {last} of {totalRecords}"
            }, {
              header: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                _createElementVNode("div", { class: "col-12" }, [
                  _createElementVNode("div", { class: "grid flex-nowrap" }, [
                    _createElementVNode("div", { class: "col" }, "Service name"),
                    _createElementVNode("div", { class: "col-1 hidden xl:block" }, "Building act"),
                    _createElementVNode("div", { class: "col-1 hidden xl:block" }, "Interval months"),
                    _createElementVNode("div", { class: "col-1 hidden xl:block" }, "Full service price"),
                    _createElementVNode("div", { class: "col-1 hidden xl:block" }, "Audit price"),
                    _createElementVNode("div", { class: "col-1 hidden xl:block" }, "Council codes"),
                    _createElementVNode("div", {
                      class: "text-center col-fixed",
                      style: {"width":"100px"}
                    }, "Active")
                  ])
                ], -1)
              ]))]),
              list: _withCtx(({data}) => [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", {
                    class: _normalizeClass(['grid flex-nowrap', { childNode: data.parentServiceId != null, parentNode: data.parentServiceId == null }])
                  }, [
                    _createElementVNode("div", _hoisted_17, [
                      _createTextVNode(_toDisplayString(data.serviceName) + " ", 1),
                      (_ctx.editMode)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            onClick: ($event: any) => (_ctx.serviceNameEdit(data))
                          }, [...(_cache[18] || (_cache[18] = [
                            _createElementVNode("i", { class: "pi pi-pencil" }, null, -1)
                          ]))], 8, _hoisted_18))
                        : _createCommentVNode("", true),
                      (_ctx.editMode)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      (!_ctx.editMode)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(data.buildingAct), 1))
                        : _createCommentVNode("", true),
                      (_ctx.editMode)
                        ? (_openBlock(), _createBlock(_component_InputText, {
                            key: 1,
                            modelValue: data.buildingAct,
                            "onUpdate:modelValue": ($event: any) => ((data.buildingAct) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      (!_ctx.editMode)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(data.intervalMonths), 1))
                        : _createCommentVNode("", true),
                      (_ctx.editMode)
                        ? (_openBlock(), _createBlock(_component_Dropdown, {
                            key: 1,
                            modelValue: data.intervalMonths,
                            "onUpdate:modelValue": ($event: any) => ((data.intervalMonths) = $event),
                            options: _ctx.serviceIntervalOptions,
                            class: "flex"
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      (!_ctx.editMode && data.fullServicePrice != null)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_25, "$" + _toDisplayString(data.fullServicePrice), 1))
                        : _createCommentVNode("", true),
                      (_ctx.editMode)
                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                            key: 1,
                            mode: "decimal",
                            minFractionDigits: 2,
                            modelValue: data.fullServicePrice,
                            "onUpdate:modelValue": ($event: any) => ((data.fullServicePrice) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      (!_ctx.editMode && data.auditPrice != null)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_27, "$" + _toDisplayString(data.auditPrice), 1))
                        : _createCommentVNode("", true),
                      (_ctx.editMode)
                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                            key: 1,
                            mode: "decimal",
                            minFractionDigits: 2,
                            modelValue: data.auditPrice,
                            "onUpdate:modelValue": ($event: any) => ((data.auditPrice) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      (!_ctx.editMode)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(data.councilCodes), 1))
                        : _createCommentVNode("", true),
                      (_ctx.editMode)
                        ? (_openBlock(), _createBlock(_component_InputText, {
                            key: 1,
                            modelValue: data.councilCodes,
                            "onUpdate:modelValue": ($event: any) => ((data.councilCodes) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      (!_ctx.editMode && data.active)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_31))
                        : _createCommentVNode("", true),
                      (_ctx.editMode)
                        ? (_openBlock(), _createBlock(_component_InputSwitch, {
                            key: 1,
                            modelValue: data.active,
                            "onUpdate:modelValue": ($event: any) => ((data.active) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                        : _createCommentVNode("", true)
                    ])
                  ], 2),
                  (_ctx.hasContent(data.description) || _ctx.editMode)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["grid",  {childNode: data.parentServiceId !== null}])
                      }, [
                        _createElementVNode("div", _hoisted_32, [
                          (_ctx.editMode)
                            ? (_openBlock(), _createElementBlock("i", {
                                key: 0,
                                class: "pi pi-arrow-up mt-3",
                                onClick: ($event: any) => (_ctx.moveService(data, true))
                              }, null, 8, _hoisted_33))
                            : _createCommentVNode("", true),
                          _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1)),
                          (_ctx.editMode)
                            ? (_openBlock(), _createElementBlock("i", {
                                key: 1,
                                class: "pi pi-arrow-down mt-3",
                                onClick: ($event: any) => (_ctx.moveService(data, false))
                              }, null, 8, _hoisted_34))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_35, [
                          _createElementVNode("div", _hoisted_36, [
                            (_ctx.hasContent(data.description) || _ctx.editMode)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_37, "Description"))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_38, [
                              (!_ctx.editMode)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(data.description), 1))
                                : _createCommentVNode("", true),
                              (_ctx.editMode)
                                ? (_openBlock(), _createBlock(_component_TextArea, {
                                    key: 1,
                                    modelValue: data.description,
                                    "onUpdate:modelValue": ($event: any) => ((data.description) = $event),
                                    rows: "2",
                                    autoResize: true
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ], 2))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["value", "paginatorTemplate"])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Dialog, {
      visible: _ctx.showAddService,
      "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.showAddService) = $event)),
      style: {"max-width":"80%"},
      width: "600px",
      modal: true,
      class: "p-fluid",
      maximizable: true
    }, _createSlots({
      header: _withCtx(() => [
        _createElementVNode("h5", null, _toDisplayString(_ctx.editServiceDialogHeader), 1)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_40, [
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _cache[20] || (_cache[20] = _createElementVNode("span", null, "Service name", -1)),
                _createVNode(_component_InputText, {
                  modelValue: _ctx.selectedService.serviceName,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedService.serviceName) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_44, [
                _cache[21] || (_cache[21] = _createElementVNode("span", null, "Parent service", -1)),
                _createVNode(_component_Dropdown, {
                  modelValue: _ctx.selectedService.parentServiceId,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedService.parentServiceId) = $event)),
                  options: _ctx.rootLevelServices,
                  optionLabel: "serviceName",
                  optionValue: "serviceId",
                  placeholder: "Select a service (leave blank for root level)",
                  filter: true,
                  disabled: !_ctx.canChangeParentStatus(_ctx.selectedService),
                  filterPlaceholder: "Find a service",
                  onChange: _ctx.onParentChanged,
                  class: "flex"
                }, null, 8, ["modelValue", "options", "disabled", "onChange"])
              ])), [
                [_directive_tooltip, !_ctx.canChangeParentStatus(_ctx.selectedService) ? 'Status cannot be changed for parent services with children': '']
              ])
            ])
          ])
        ])
      ]),
      _: 2
    }, [
      (!_ctx.selectedService.serviceId)
        ? {
            name: "footer",
            fn: _withCtx(() => [
              _createVNode(_component_Button, {
                class: "cancel",
                icon: "pi pi-times",
                label: "Cancel",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showAddService = false))
              }),
              _createVNode(_component_Button, {
                class: "",
                icon: "pi pi-check",
                label: "Add",
                onClick: _ctx.addService
              }, null, 8, ["onClick"])
            ]),
            key: "0"
          }
        : {
            name: "footer",
            fn: _withCtx(() => [
              _createVNode(_component_Button, {
                class: "cancel",
                icon: "pi pi-times",
                label: "Cancel",
                onClick: _ctx.cancel
              }, null, 8, ["onClick"]),
              _createVNode(_component_Button, {
                class: "",
                icon: "pi pi-check",
                label: "Close",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showAddService = false))
              })
            ]),
            key: "1"
          }
    ]), 1032, ["visible"]),
    _createVNode(_component_Button, {
      class: "sticky-button cancel",
      icon: "pi pi-times",
      label: "Cancel",
      onClick: _ctx.cancel
    }, null, 8, ["onClick"]),
    _createVNode(_component_Button, {
      class: "sticky-button",
      icon: "pi pi-check",
      label: "Save",
      onClick: _ctx.save
    }, null, 8, ["onClick"])
  ], 64))
}